//var $ = require('jquery');
//window.$ = $;
//require('bootstrap');

//require('./../../bootstrap');

require('./../utility/float-input-labels');
require('./../app');

import Inputmask from "inputmask";
require('./../utility/country_phone_code');
